
export default function BookingHero() {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/aa8c2276e6eae0d7108bfd7655c4260c.jpg')`,
        }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"
        aria-hidden="true"
      />
      
      <div className="relative z-10 text-center px-6 py-32 max-w-4xl mx-auto">
        <p className="text-amber-400 text-sm font-medium tracking-wider uppercase mb-4">
          Schedule Your Visit
        </p>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight">
          Book a Site Visit
        </h1>
        <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto font-light">
          Let us visit your property to assess your painting and decorating needs.
          We&apos;ll provide a detailed, no‑obligation quote tailored to your project.
        </p>
      </div>
    </section>
  );
}
